export default __webpack_public_path__ + "static/media/Ariana 9781408339534.15842ef9.jpg";